import React, { useState } from 'react';

// Блок "Security" для вкладки Profile: зміна пароля та email (обидва — з поточним паролем)
const API = 'https://orkxz4jpah.execute-api.us-east-1.amazonaws.com/password-reset';

function ChangePasswordCard({ genesisID, email, onEmailChanged }) {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState('');
  const [pw1, setPw1] = useState('');
  const [pw2, setPw2] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const reset = () => { setCurrent(''); setPw1(''); setPw2(''); setShowPw(false); };

  // --- зміна email ---
  const [mode, setMode] = useState('password'); // 'password' | 'email'
  const [newEmail, setNewEmail] = useState('');
  const [emailPw, setEmailPw] = useState('');

  const submitEmail = async (e) => {
    e.preventDefault();
    if (busy) return;
    setMsg(null);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(newEmail.trim())) {
      setMsg({ type: 'error', text: 'Please enter a valid email address' });
      return;
    }
    setBusy(true);
    try {
      const res = await fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'changeEmail', genesisID, currentPassword: emailPw, newEmail: newEmail.trim() }),
      });
      const r = await res.json();
      if (r.success) {
        setNewEmail(''); setEmailPw('');
        setOpen(false);
        setMsg({ type: 'ok', text: `Email changed to ${r.email}. A notice was sent to your previous email.` });
        if (onEmailChanged) onEmailChanged(r.email);
      } else {
        setMsg({ type: 'error', text: r.error || 'Something went wrong. Please try again.' });
      }
    } catch {
      setMsg({ type: 'error', text: 'Network error. Please try again.' });
    } finally {
      setBusy(false);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setMsg(null);
    if (pw1.length < 8 || !/[A-Za-z]/.test(pw1) || !/\d/.test(pw1)) {
      setMsg({ type: 'error', text: 'Password must be at least 8 characters and contain letters and digits' });
      return;
    }
    if (pw1 !== pw2) { setMsg({ type: 'error', text: 'New passwords do not match' }); return; }
    setBusy(true);
    try {
      const res = await fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'change', genesisID, currentPassword: current, newPassword: pw1 }),
      });
      const r = await res.json();
      if (r.success) {
        reset();
        setOpen(false);
        setMsg({ type: 'ok', text: 'Password changed.' });
      } else {
        setMsg({ type: 'error', text: r.error || 'Something went wrong. Please try again.' });
      }
    } catch {
      setMsg({ type: 'error', text: 'Network error. Please try again.' });
    } finally {
      setBusy(false);
    }
  };

  const input = { width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '10px', boxSizing: 'border-box', fontSize: '14px' };

  return (
    <div className="expandable-section">
      <div className="section-header" onClick={() => { setOpen(!open); setMsg(null); }}>
        <span className={`expand-icon ${open ? 'expanded' : ''}`}>▶</span>
        <h3>Security</h3>
      </div>
      {(open || msg) && (
        <div className="section-content" style={{ textAlign: 'left' }}>
          {msg && (
            <p style={{ margin: '0 0 12px 0', fontSize: '14px', color: msg.type === 'error' ? '#b42318' : '#166534' }}>
              {msg.type === 'error' ? '❌ ' : '✅ '}{msg.text}
            </p>
          )}
          {open && (
            <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
              {[['password', 'Change password'], ['email', 'Change email']].map(([m, label]) => (
                <button key={m} type="button" onClick={() => { setMode(m); setMsg(null); }}
                  style={{ flex: 1, padding: '8px', borderRadius: '8px', fontSize: '13px', fontWeight: 600, cursor: 'pointer',
                    border: '1px solid ' + (mode === m ? '#1e293b' : '#ddd'), background: mode === m ? '#1e293b' : '#fff', color: mode === m ? '#fff' : '#333' }}>
                  {label}
                </button>
              ))}
            </div>
          )}
          {open && mode === 'email' && (
            <form onSubmit={submitEmail}>
              <div style={{ fontSize: '13px', color: '#666', marginBottom: '10px' }}>Current email: <strong>{email || '—'}</strong></div>
              <input type="text" name="username" value={genesisID} autoComplete="username" readOnly hidden />
              <input style={input} type="email" placeholder="New email" value={newEmail}
                onChange={(e) => setNewEmail(e.target.value)} required autoComplete="email" />
              <input style={input} type={showPw ? 'text' : 'password'} placeholder="Current password"
                value={emailPw} onChange={(e) => setEmailPw(e.target.value)} required autoComplete="current-password" />
              <button type="button" onClick={() => setShowPw(!showPw)}
                style={{ background: 'none', border: 'none', color: '#4f46e5', fontSize: '13px', cursor: 'pointer', padding: 0, marginBottom: '12px' }}>
                {showPw ? '🙈 Hide password' : '👁 Show password'}
              </button>
              <button type="submit" disabled={busy}
                style={{ width: '100%', padding: '12px', borderRadius: '8px', border: 'none', background: '#1e293b', color: '#fff', fontWeight: 600, cursor: 'pointer' }}>
                {busy ? 'Saving...' : 'Change email'}
              </button>
            </form>
          )}
          {open && mode === 'password' && (
            <form onSubmit={submit}>
              <input type="text" name="username" value={genesisID} autoComplete="username" readOnly hidden />
              <input style={input} type={showPw ? 'text' : 'password'} placeholder="Current password"
                value={current} onChange={(e) => setCurrent(e.target.value)} required autoComplete="current-password" />
              <input style={input} type={showPw ? 'text' : 'password'} placeholder="New password"
                value={pw1} onChange={(e) => setPw1(e.target.value)} required autoComplete="new-password" />
              <input style={input} type={showPw ? 'text' : 'password'} placeholder="Repeat new password"
                value={pw2} onChange={(e) => setPw2(e.target.value)} required autoComplete="new-password" />
              <button type="button" onClick={() => setShowPw(!showPw)}
                style={{ background: 'none', border: 'none', color: '#4f46e5', fontSize: '13px', cursor: 'pointer', padding: 0, marginBottom: '6px' }}>
                {showPw ? '🙈 Hide passwords' : '👁 Show passwords'}
              </button>
              <div style={{ fontSize: '12px', color: '#888', marginBottom: '12px' }}>
                Minimum 8 characters, letters and digits. Forgot the current one? Log out and use "Forgot password?" on the login page.
              </div>
              <button type="submit" disabled={busy}
                style={{ width: '100%', padding: '12px', borderRadius: '8px', border: 'none', background: '#1e293b', color: '#fff', fontWeight: 600, cursor: 'pointer' }}>
                {busy ? 'Saving...' : 'Change password'}
              </button>
            </form>
          )}
        </div>
      )}
    </div>
  );
}

export default ChangePasswordCard;
